import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { ContractFormsContainer } from "../contractform/containers/ContractFormsContainer";
import { ContractAnniversaryDateListContainer } from "./containers/ContractAnniversaryDateListContainer";
import { ContractCreateContainer } from "./containers/ContractCreateContainer";
import { ContractDetailContainer } from "./containers/ContractDetailContainer";
import { ContractFixationAnniversaryListContainer } from "./containers/ContractFixationAnniversaryListContainer";
import { ContractListContainer } from "./containers/ContractListContainer";
import { ContractPredictedCommissionsListContainer } from "./containers/ContractPredictedCommissionsListContainer";
import { ContractUnpaidListContainer } from "./containers/ContractUnpaidListContainer";
import { CONTRACT_ROUTE_PATHS } from "./paths";

const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<ContractListContainer key={CONTRACT_ROUTE_PATHS.list.path} />}
          permissions={[
            Permission.INSURANCE_READ,
            Permission.LOAN_READ,
            Permission.INVESTMENT_READ,
            Permission.DEPOSIT_READ,
            Permission.SECOND_PILLAR_READ,
            Permission.THIRD_PILLAR_READ,
            Permission.GENERIC_READ,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.predictedCommissions.path}
      element={
        <PageWithPermission
          component={<ContractPredictedCommissionsListContainer key={CONTRACT_ROUTE_PATHS.predictedCommissions.path} />}
          permissions={[
            Permission.INSURANCE_READ,
            Permission.LOAN_READ,
            Permission.INVESTMENT_READ,
            Permission.DEPOSIT_READ,
            Permission.SECOND_PILLAR_READ,
            Permission.THIRD_PILLAR_READ,
            Permission.GENERIC_READ,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.anniversaryDate.path}
      element={
        <PageWithPermission
          component={<ContractAnniversaryDateListContainer key={CONTRACT_ROUTE_PATHS.anniversaryDate.path} />}
          permissions={[Permission.INSURANCE_READ]}
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.fixationAnniversaryDate.path}
      element={
        <PageWithPermission
          component={
            <ContractFixationAnniversaryListContainer key={CONTRACT_ROUTE_PATHS.fixationAnniversaryDate.path} />
          }
          permissions={[Permission.LOAN_READ]}
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.unpaid.path}
      element={
        <PageWithPermission
          component={<ContractUnpaidListContainer key={CONTRACT_ROUTE_PATHS.unpaid.path} />}
          permissions={[Permission.INSURANCE_READ]}
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.detail.path}
      element={
        <PageWithPermission
          component={<ContractDetailContainer />}
          permissions={[
            Permission.INSURANCE_READ,
            Permission.LOAN_READ,
            Permission.INVESTMENT_READ,
            Permission.DEPOSIT_READ,
            Permission.SECOND_PILLAR_READ,
            Permission.THIRD_PILLAR_READ,
            Permission.GENERIC_READ,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.create.path}
      element={
        <PageWithPermission
          component={<ContractCreateContainer />}
          permissions={[
            Permission.INSURANCE_CREATE,
            Permission.LOAN_CREATE,
            Permission.INVESTMENT_CREATE,
            Permission.DEPOSIT_CREATE,
            Permission.SECOND_PILLAR_CREATE,
            Permission.THIRD_PILLAR_CREATE,
            Permission.GENERIC_CREATE,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.forms.path}
      element={
        <PageWithPermission
          component={<ContractFormsContainer />}
          permissions={[
            Permission.INSURANCE_READ,
            Permission.LOAN_READ,
            Permission.DEPOSIT_READ,
            Permission.SECOND_PILLAR_READ,
            Permission.THIRD_PILLAR_READ,
          ]}
          anyPermission
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
